import * as React from 'react';
import styled from 'styled-components';
import { Button, variants } from '../Button';
import { IConfirmButtonsProps } from './ConfirmButtons.types';

const ConfirmButtonContainer = styled.div`
  diplay: flex;
`;

const ConfirmButton = styled(Button)`
  .button {
    display: inline-flex;
    align-items: center;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 24px;
    height: 24px;
    margin: unset;
  }
`;

const ConfirmButtons: React.FC<IConfirmButtonsProps> = (
  props: IConfirmButtonsProps
) => {
  const {
    className,
    confirmButtonText,
    onCancel,
    onConfirm,
    confirmButtonTestId,
    cancelButtonTestId
  } = props;
  return (
    <ConfirmButtonContainer className={`${className}`}>
      <ConfirmButton
        testId={cancelButtonTestId || 'confirm-button-1'}
        className="m-r-16"
        colorType={variants.WHITE}
        text="Cancel"
        type="button"
        onClick={onCancel}
      />
      <ConfirmButton
        testId={confirmButtonTestId || 'confirm-button-2'}
        text={confirmButtonText ?? 'Confirm'}
        type="button"
        onClick={onConfirm}
        colorType={variants.PRIMARY}
      />
    </ConfirmButtonContainer>
  );
};

export default ConfirmButtons;
